export default "Lav ægte jægerstenaldersnor! Prøv at fremstille jeres egen snor af bast. Snoren I kan fx bruge til at binde jeres trækbåre sammen med.";